import { Switch } from 'react-router-dom'
import { CIMSPage, Permission } from '@cims-online/shared'
import { ProtectedRoute } from 'components/ProtectedRoute'
import ApprovalGroups from './components/ApprovalGroups'
import Concurrences from './components/Concurrences'
import Notifications from './components/Notifications'
import Disciplines from './components/Disciplines'
import FDCTracker from './components/FDCTracker'
import UserRoleSelectProvider from 'components/CIMSSelect/common/UserRoleSelect/UserRoleSelectContext'
import FDCQuickLinks from './components/FDCQuickLinks'

const FieldDesignChanges: React.FC = () => {
  return (
    <Switch>
      <ProtectedRoute
        path={[CIMSPage.FDCTracker.recordPath, CIMSPage.FDCTracker.projectPath]}
        permissions={Permission.ViewFieldDesignChange}
      >
        <FDCTracker />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.FDCConcurrences.projectPath}
        permissions={[
          Permission.ViewFDCConcurrenceGroup,
          Permission.ViewFDCConcurrenceLevel,
        ]}
      >
        <Concurrences />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.FDCApprovalGroups.projectPath}
        permissions={Permission.ViewFDCApprovalGroup}
      >
        <UserRoleSelectProvider>
          <ApprovalGroups />
        </UserRoleSelectProvider>
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.FDCDisciplines.projectPath}
        permissions={Permission.ViewFDCDiscipline}
      >
        <Disciplines />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.FDCQuickLinks.projectPath}
        permissions={Permission.ViewFDCQuickLink}
      >
        <FDCQuickLinks />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.FDCNotifications.projectPath}
        permissions={Permission.ViewFDCNotification}
      >
        <Notifications />
      </ProtectedRoute>
    </Switch>
  )
}

export default FieldDesignChanges
